import { useMemo, useState, useEffect } from "react";

const EquifaxReport = ({
  states,
  data,
  onClose,
  isOpen,
  Equifaxv2Report,
  Equifaxv2Error,
}) => {
  useEffect(() => {
    //  console.log("Equifaxv2Report",Equifaxv2Report);
    //  console.log("Equifaxv2Error",Equifaxv2Error);
    //   console.log("data",data);
  }, [Equifaxv2Report, Equifaxv2Error, data]);

  const stateCodeToLabel = useMemo(() => {
    if (!Array.isArray(states)) return {};

    return states.reduce((acc, curr) => {
      acc[curr.value] = curr.label;
      return acc;
    }, {});
  }, [states]);

  const [isPrinting, setIsPrinting] = useState(false);

  if (!data || !data?.data) return null;

  const reportData = data || Equifaxv2Report;
  const isNoData = reportData?.data?.length === 0;

  const glossaryData = [
    { code: "000", description: "Current account" },
    { code: "CLSD", description: "Paid or closed account / zero balance" },
    { code: "NEW", description: "New Account" },
    { code: "LNSB", description: "Loan Submitted" },
    { code: "LAND", description: "Loan Approved - Not yet disbursed" },
    { code: "INAC", description: "Account is Inactive" },
    { code: "CON", description: "Contact Member for Status" },
    { code: "DEC", description: "Loan Declined" },
    { code: "01+", description: "1-30 days past due" },
    { code: "31+", description: "31-60 days past due" },
    { code: "61+", description: "61-90 days past due" },
    { code: "91+", description: "91-120 days past due" },
    { code: "121+", description: "121-179 days past due" },
    { code: "181+", description: "180 or more days past due" },
    { code: "STD", description: "Standard" },
    { code: "SUB", description: "Sub-standard" },
    { code: "DBT", description: "Doubtful" },
    { code: "LOS", description: "Loss" },
    { code: "SMA", description: "Special Mention Accounts" },
    {
      code: "SMA 0",
      description:
        "Principal or interest payment not overdue for more than 30 days but showing signs of stress",
    },
    {
      code: "SMA 1",
      description: "Principal or interest payment overdue between 31-60 days",
    },
    {
      code: "SMA 2",
      description: "Principal or interest payment overdue between 61-90 days",
    },
    { code: "DBT 1", description: "Doubtful - 1" },
    { code: "DBT 2", description: "Doubtful - 2" },
    { code: "DBT 3", description: "Doubtful - 3" },

    { code: "LR", description: "Loss - Restructured" },
    { code: "LWR", description: "Loss - Written off" },
    { code: "LRS", description: "Loss - Restructured - Settled" },
    { code: "LWS", description: "Loss - Written off - Settled" },
    { code: "LSS", description: "Loss - Settled" },
    { code: "LRSR", description: "Loss - Restructured - Restructured" },
    { code: "LWSR", description: "Loss - Written off - Restructured" },
    { code: "LRSS", description: "Loss - Restructured - Settled - Settled" },
    { code: "LWSS", description: "Loss - Written off - Settled - Settled" },
    {
      code: "LRRS",
      description: "Loss - Restructured - Restructured - Settled",
    },
    {
      code: "LWRS",
      description: "Loss - Written off - Restructured - Settled",
    },
    {
      code: "LRRW",
      description: "Loss - Restructured - Restructured - Written off",
    },
    {
      code: "LWRW",
      description: "Loss - Written off - Restructured - Written off",
    },
    {
      code: "LRRWS",
      description: "Loss - Restructured - Restructured - Written off - Settled",
    },
    {
      code: "LWRWS",
      description: "Loss - Written off - Restructured - Written off - Settled",
    },
    {
      code: "LRRSR",
      description: "Loss - Restructured - Restructured - Restructured",
    },
    {
      code: "LWRSR",
      description: "Loss - Written off - Restructured - Restructured",
    },
    {
      code: "LRRWR",
      description:
        "Loss- Restructured- Restructured- Written off- Restructured",
    },
    {
      code: "LWRWR",
      description: "Loss- Written off- Restructured- Written off- Restructured",
    },
    { code: "NS", description: "Not a Suit Filed Case" },
    { code: "SF", description: "Suit Filed" },
    { code: "WDF", description: "Willful Default" },
    { code: "SFR", description: "Suit Filed - Restructured" },
    { code: "SFWD", description: "Suit Filed - Willful Default" },
    { code: "SFWO", description: "Suit Filed and Written Off" },
    { code: "WDWO", description: "Willful Default and Written Off" },
    {
      code: "SWDW",
      description: "Suit Filed, Willful Default and Written Off",
    },
    { code: "FPD", description: "First Payment Default" },
    { code: "TP", description: "Trial in Progress" },
    { code: "DI", description: "Decree issued by court" },
    { code: "ED", description: "Execution of Decree" },
    { code: "NAOC", description: " Notional Amount of Contract" },
    {
      code: "NAORC",
      description: " Notional Amount of Out-standing Restructured Contracts",
    },
    {
      code: "WAMPOC",
      description: "Weighted Average maturity period of Contrac",
    },
    { code: "*", description: "Data Not Reported" },
    { code: "ERS", description: "Equifax Risk Score" },

    { code: "CF", description: "Credit Facilities" },
    { code: "NI", description: "Non-Installment" },
    { code: "I", description: "Installment" },
    { code: "HC", description: "Installment" },
    { code: "OT", description: "Other" },

    { code: "CC", description: "Credit Card" },
    { code: "PL", description: "Personal Loan" },
    { code: "HL", description: "Home Loan" },
    { code: "VL", description: "Vehicle Loan" },
    { code: "AL", description: "Auto Loan" },
    { code: "GL", description: "Gold Loan" },
    { code: "BL", description: "Business Loan" },
    { code: "EL", description: "Education Loan" },
    { code: "CD", description: "Consumer Durable Loan" },
    { code: "SME", description: "Small and Medium Enterprise" },
    { code: "LAP", description: "Loan Against Property" },
    { code: "WL", description: "Working Capital Loan" },
    { code: "TL", description: "Term Loan" },
    { code: "BS", description: "Business" },
    { code: "SL", description: "Secured Loan" },
    { code: "USL", description: "Unsecured Loan" },
    { code: "NF", description: "Non-Funded" },
    { code: "TL", description: "Term Loan" },
    { code: "01", description: "Account Ownership Disputed" },
    { code: "02", description: "Account Status Disputed" },
    { code: "03", description: "Account Balance Disputed" },
    { code: "04", description: "Account Ownership Type Disputed" },
    { code: "05", description: "Account Needs to be closed" },
    { code: "06", description: "Account History Disputed" },
    { code: "07", description: "Suit Filed / Willful Status Disputed" },
    { code: "08", description: "Asset Classification Status Disputed" },
    { code: "09", description: "Sanction Amount Disputed" },
    { code: "10", description: "Name Correction Requested" },
    { code: "11", description: "Address Information Disputed" },
    { code: "12", description: "DOB Disputed" },
    { code: "13", description: "Contact Number Disputed" },
    { code: "14", description: "Gender Flag Disputed" },
    { code: "15", description: "Total Income Disputed" },
    { code: "16", description: "Occupation Disputed" },
    { code: "17", description: "PAN Information Disputed" },
    { code: "18", description: "Voter Information Disputed" },
    { code: "19", description: "Passport Information Disputed" },
    { code: "20", description: "Driver's License Information Disputed" },
    { code: "21", description: "State Code Disputed" },
    { code: "22", description: "Date Closed Disputed" },
    { code: "23", description: "Credit Limit Disputed" },
    { code: "24", description: "Write-off / Settled Amount Disputed" },
    { code: "25", description: "Loan / Credit Type Disputed" },
    { code: "26", description: "Collateral Details Disputed" },
    { code: "27", description: "Email ID Disputed" },
    { code: "28", description: "MFI - Loan Category Disputed" },
    { code: "29", description: "MFI - Repayment Frequency Disputed" },
    { code: "30", description: "MFI - Installment Amount Disputed" },
    { code: "31", description: "MFI - Key Person Name Disputed" },
    { code: "32", description: "Dispute Closed" },
  ];

  const printDiv = () => {
    setIsPrinting(true);

    const printWindow = window.open("", "", "height=600,width=800");
    const printContents = document.getElementById("invoicedata").innerHTML;

    printWindow.document.write(`
    <html>
        <head>
            <title>Print</title>
            <link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">
            <style>
                * {
                    -webkit-print-color-adjust: exact !important;
                    print-color-adjust: exact !important;
                }

                @media print {
                    @page {
                        /* Reserve space for fixed header on every page */
                        margin-top: 20px;
                        margin-bottom: 20px;
                        margin-left: 20px;
                        margin-right: 20px;
                    }

                    body {
                        margin: 0;
                        padding: 0;
                    }

                    /* ===== REPEATING HEADER (NO OVERLAP) =====
                       Use a table header group so the browser repeats it per page. */
                    .print-report-table {
                        width: 100%;
                        border-collapse: collapse;
                    }

                    .print-report-table thead {
                        display: table-header-group;
                    }

                    .print-report-table tbody {
                        display: table-row-group;
                    }

                    .print-header-cell {
                        background: white;
                        padding: 10px 32px;
                        border-bottom: 1px solid #e5e7eb;
                    }

                    /* ===== CONTENT AREA ===== */
                    .print-body {
                        margin-top: 0;
                        padding-top: 0;
                        position: relative;
                        z-index: 1;
                    }

                    /* ===== SECTION SAFETY ===== */
                    .section-block {
                        page-break-inside: avoid;
                        break-inside: avoid;
                        margin-top: 12px;
                        position: relative;
                    }

                    .section-title {
                        page-break-after: avoid;
                        break-after: avoid;
                    }

                    .section-body {
                        page-break-before: avoid;
                        break-before: avoid;
                    }

                    .account-header {
                        page-break-after: avoid;
                        break-after: avoid;
                    }

                    /* Allow table to flow naturally */
                    .payment-history-wrapper {
                        page-break-inside: auto;
                        break-inside: auto;
                    }

                    /* If this section gets large (payment history), allow splitting across pages */
                    .allow-page-break,
                    .allow-page-break .section-body,
                    .allow-page-break .payment-history-wrapper {
                        page-break-inside: auto !important;
                        break-inside: auto !important;
                    }

                    .allow-page-break table.print-table {
                        page-break-inside: auto !important;
                        break-inside: auto !important;
                    }

                    /* Repeat table header on new page */
                    .print-table thead {
                        display: table-header-group;
                    }

                    /* Never split rows */
                    .print-table tr {
                        page-break-inside: avoid;
                        break-inside: avoid;
                    }

                    .print-table {
                        margin-top: 4px;
                    }

                    /* ===== TABLE BEHAVIOR ===== */
                    table {
                        width: 100%;
                        page-break-inside: auto;
                    }

                    thead {
                        display: table-header-group;
                    }

                    tr {
                        page-break-inside: avoid;
                        break-inside: avoid;
                    }

                    /* Page break handling - adds extra top margin on new pages */
                    .print-page-break {
                        break-before: page !important;
                        page-break-before: always !important;
                        padding-top: 0 !important;
                        margin-top: 0 !important;
                    }
                }

                /* Hide header on screen view */
                @media screen {
                    .print-header-cell {
                        border-bottom: 1px solid #e5e7eb;
                    }
                }
            </style>
        </head>
        <body>
            ${printContents}
        </body>
    </html>
    `);

    printWindow.document.close();
    printWindow.focus();

    setTimeout(() => {
      printWindow.print();
      setIsPrinting(false);
    }, 300);
  };
  const formatLabel = (key) =>
    key
      .replace(/_/g, " ")
      .toLowerCase()
      .replace(/\b\w/g, (c) => c.toUpperCase());

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";

    const [year, month, day] = dateStr.split("-");
    return `${day}/${month}/${year}`;
  };

  // -------------------------------------------------------------------------------------//
  // personal information section validater
  const personalInfo = reportData?.data?.personal_information || {};

  const hasAnyPersonalInfo = Object.values(personalInfo).some(
    (v) => v !== null && v !== "" && v !== "NA" && v !== "N/A",
  );

  // National doc section validater
  const nationalDocs = reportData?.data?.national_document_data || {};
  const isValidValue = (v) =>
    v !== null && v !== "" && v !== "NA" && v !== "N/A";

  const hasAnyKey = (obj) =>
    obj && typeof obj === "object" && Object.keys(obj).length > 0;

  const hasAnyNationalDocs = Object.values(nationalDocs || {}).some(
    (records) => Array.isArray(records) && records.length > 0,
  );
  const getColumnsFromRecords = (records = []) =>
    Array.from(new Set(records.flatMap((r) => Object.keys(r || {}))));

  //  address
  const addressDoc = reportData?.data?.address;

  const hasAnyAddressDoc = Array.isArray(addressDoc) && addressDoc.length > 0;

  const getAddressColumns = (addresses = []) =>
    Array.from(
      new Set(
        addresses
          .filter((addr) => addr && hasAnyKey(addr))
          .flatMap((addr) => Object.keys(addr)),
      ),
    );

  // phone  and email
  const getDynamicColumns = (items = []) =>
    Array.from(
      new Set(
        items
          .filter((item) => item && hasAnyKey(item))
          .flatMap((item) => Object.keys(item)),
      ),
    );

  // Account Details:
  const accountDetail = reportData?.data?.account_detail || {};

  const chunkArray = (arr, size) => {
    const result = [];
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }
    return result;
  };

  //  account summary
  const accountSummary = reportData?.data?.account_summary || {};
  const hasAnyAccountSummary = Object.values(accountSummary).some(
    (v) => v !== null && v !== "" && v !== "NA" && v !== "N/A",
  );

  const formatTwoDecimal = (value) => {
    if (isNaN(value)) return value;
    return Number(value).toFixed(2);
  };

  // list of institution
  const listOfInstitutioDoc = reportData?.data?.list_of_institution;

  const hasAnyListOfInstitutioDoc =
    Array.isArray(listOfInstitutioDoc) && listOfInstitutioDoc.length > 0;

  const getInstitutionColumns = (institutions = []) => {
    const columnSet = new Set();

    institutions.forEach((inst) => {
      Object.keys(inst || {}).forEach((key) => {
        columnSet.add(key);
      });
    });

    return Array.from(columnSet);
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex justify-center items-center ">
      <div className="bg-white w-full max-w-3xl shadow-lg flex flex-col max-h-[90vh]">
        <div className="overflow-y-auto p-4 pl-8 pr-8 flex-1 ">
          <div id="invoicedata">
            <table className="print-report-table">
              <thead>
                <tr>
                  <td className="print-header-cell">
                    <div
                      className={`flex justify-between border-b border-gray-300 items-center ${
                        isNoData ? "gap-20" : "gap-18"
                      }`}
                    >
                      <div className="text-red-800 font-extrabold text-2xl tracking-wide italic">
                        EQUIFAX
                      </div>

                      <div className="text-center">
                        <div className="text-xl text-red-900">
                          Equifax Credit Report with Score
                        </div>
                      </div>

                      <div className="text-center font-bold text-gray-800">
                        Credit Score:
                        <span className="text-gray-700 ml-1 text-xl">
                          {reportData?.data?.score_detail?.[0]?.value || "N/A"}
                        </span>
                      </div>
                    </div>
                  </td>
                </tr>
              </thead>

              <tbody className="print-body">
                <tr>
                  <td>
                    {isNoData ? (
                      <>
                        <div className="flex w-full flex-col justify-center items-center min-h-[70vh] text-center">
                          <div className="text-red-800 font-extrabold text-3xl mb-4">
                            EQUIFAX
                          </div>

                          <h2 className="text-red-700 text-2xl font-semibold mb-3">
                            Credit Report Not Available
                          </h2>

                          <p className="text-gray-700 text-lg max-w-xl">
                            {reportData?.message ||
                              reportData?.status?.message ||
                              "No records found with the given information."}
                          </p>

                          <p className="mt-2 text-sm text-gray-500">
                            Please verify customer details and try again.
                          </p>
                        </div>
                      </>
                    ) : (
                      <>
                        {/* PERSONAL DETAILS */}
                        <Section
                          title={
                            <span className="text-base">
                              <span className="font-bold text-gray-500 text-xl">
                                Consumer Name:
                              </span>{" "}
                              <span className="font-semibold text-gray-500 text-xl">
                                {reportData?.data?.personal_information
                                  ?.full_name || "N/A"}
                              </span>
                            </span>
                          }
                        >
                          <div className="w-full col-span-2 md:col-span-4">
                            <div className="grid grid-cols-3 md:grid-cols-3 gap-0">
                              <div className=" ">
                                <div className="bg-red-800 text-white font-semibold text-sm px-2 py-1">
                                  Personal Information
                                </div>

                                <div className="p-2 space-y-1 text-sm">
                                  {hasAnyPersonalInfo ? (
                                    Object.entries(personalInfo).map(
                                      ([key, value]) => (
                                        <Detail
                                          key={key}
                                          label={formatLabel(key)}
                                          value={
                                            isValidValue(value)
                                              ? key
                                                  .toLowerCase()
                                                  .includes("date")
                                                ? formatDate(value)
                                                : value
                                              : "N/A"
                                          }
                                        />
                                      ),
                                    )
                                  ) : (
                                    <div className="text-gray-500 text-center">
                                      Data not found
                                    </div>
                                  )}
                                </div>
                              </div>

                              <div className=" ">
                                <div className="bg-red-800 text-white font-semibold text-sm px-2 py-1">
                                  Identification
                                </div>

                                <div className="p-2 text-sm space-y-2">
                                  {hasAnyNationalDocs ? (
                                    Object.entries(nationalDocs).map(
                                      ([docType, records]) => {
                                        const value =
                                          Array.isArray(records) &&
                                          records.length > 0
                                            ? records.find((r) =>
                                                isValidValue(r?.value),
                                              )?.value
                                            : null;

                                        return (
                                          <div key={docType} className="">
                                            <span className="text-xs text-gray-500">
                                              {formatLabel(docType)}:{" "}
                                            </span>
                                            <span className="text-xs text-gray-900">
                                              {value || "NA"}
                                            </span>
                                          </div>
                                        );
                                      },
                                    )
                                  ) : (
                                    <div className="text-gray-500 text-center">
                                      Data not found
                                    </div>
                                  )}
                                </div>
                              </div>

                              <div className=" ">
                                <div className="bg-red-800 text-white font-semibold text-sm px-2 py-1">
                                  Contact Details
                                </div>

                                <div className="p-2 text-sm space-y-2">
                                  {Array.isArray(reportData?.data?.phone) &&
                                  reportData.data.phone.some((p) =>
                                    isValidValue(p?.value),
                                  ) ? (
                                    reportData.data.phone.map((phone, idx) => (
                                      <div key={idx} className="">
                                        <span className="text-xs text-gray-500">
                                          Phone {idx + 1}:{" "}
                                        </span>
                                        <span className="text-xs text-gray-900">
                                          {phone?.value || "NA"}
                                        </span>
                                      </div>
                                    ))
                                  ) : (
                                    <div className="text-gray-500 text-center">
                                      Data not found
                                    </div>
                                  )}
                                  {Array.isArray(reportData?.data?.email) &&
                                  reportData.data.email.some((e) =>
                                    isValidValue(e?.value),
                                  )
                                    ? reportData.data.email.map(
                                        (email, idx) => (
                                          <div key={`email-${idx}`}>
                                            <span className="text-xs text-gray-500">
                                              Email {idx + 1}:{" "}
                                            </span>
                                            <span className="text-xs text-gray-900 break-all">
                                              {email?.value
                                                ? email.value.toLowerCase()
                                                : "NA"}
                                            </span>
                                          </div>
                                        ),
                                      )
                                    : null}
                                </div>
                              </div>
                            </div>
                          </div>
                        </Section>

                        {/* National Document DETAILS */}

                        {/* <Section title="National Document Details:">
                                                    {hasAnyNationalDocs ? (
                                                        Object.entries(nationalDocs || {}).map(([docType, records]) => {
                                                            // Case 1: not array / empty
                                                            if (!Array.isArray(records) || records.length === 0) {
                                                                return (
                                                                    <div key={docType} className="col-span-2">
                                                                        <div className="font-semibold text-red-800 mb-1">
                                                                            {formatLabel(docType)}
                                                                        </div>
                                                                        <div className="text-gray-500">No record found</div>
                                                                    </div>
                                                                );
                                                            }

                                                            // Case 2: remove empty objects
                                                            const usableRecords = records.filter(
                                                                (r) => r && hasAnyKey(r)
                                                            );

                                                            if (usableRecords.length === 0) {
                                                                return (
                                                                    <div key={docType} className="col-span-2">
                                                                        <div className="font-semibold text-red-700 mb-1">
                                                                            {formatLabel(docType)}
                                                                        </div>
                                                                        <div className="text-gray-500">No record found</div>
                                                                    </div>
                                                                );
                                                            }

                                                            const columns = getColumnsFromRecords(usableRecords);

                                                            return (
                                                                <div key={docType} className="col-span-2">
                                                                    <div className="font-semibold text-red-700 mb-1">
                                                                        {formatLabel(docType)}
                                                                    </div>

                                                                    <div className="overflow-x-auto ">
                                                                        <table className="min-w-full text-sm border-collapse">
                                                                            <thead className="bg-red-800 text-white">
                                                                                <tr>
                                                                                    {columns.map((col) => (
                                                                                        <th
                                                                                            key={col}
                                                                                            className=" px-2 py-1 text-left font-semibold text-xs"
                                                                                        >
                                                                                            {formatLabel(col)}
                                                                                        </th>
                                                                                    ))}
                                                                                </tr>
                                                                            </thead>

                                                                            <tbody>
                                                                                {usableRecords.map((record, rowIdx) => (
                                                                                    <tr key={rowIdx} className="even:bg-gray-100">
                                                                                        {columns.map((col) => (
                                                                                            <td key={col} className="px-2 py-1 text-xs text-gray-700">
                                                                                                {isValidValue(record[col])
                                                                                                    ? col === "reported_date"
                                                                                                        ? formatDate(record[col])
                                                                                                        : record[col]
                                                                                                    : "NA"}
                                                                                            </td>
                                                                                        ))}
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            );
                                                        })
                                                    ) : (
                                                        <div className="col-span-2 text-center text-gray-500">
                                                            Data not found
                                                        </div>
                                                    )}
                                                </Section> */}

                        {/* ADDRESS DETAILS */}
                        <Section title="Consumer Address:">
                          {hasAnyAddressDoc ? (
                            (() => {
                              const usableAddresses = addressDoc.filter(
                                (addr) => addr && hasAnyKey(addr),
                              );

                              if (usableAddresses.length === 0) {
                                return (
                                  <div className="col-span-2 text-center text-gray-500">
                                    Data not found
                                  </div>
                                );
                              }

                              const columns =
                                getAddressColumns(usableAddresses);

                              return (
                                <div className="col-span-2 overflow-x-auto">
                                  <table className="min-w-full  border-gray-300 text-sm">
                                    <thead className="bg-red-800 text-white">
                                      <tr>
                                        {columns.map((col) => (
                                          <th
                                            key={col}
                                            className=" px-2 py-1 text-left font-semibold text-xs"
                                          >
                                            {formatLabel(col)}
                                          </th>
                                        ))}
                                      </tr>
                                    </thead>

                                    <tbody>
                                      {usableAddresses.map((address, index) => (
                                        <tr
                                          key={index}
                                          className="even:bg-gray-100"
                                        >
                                          {columns.map((field) => (
                                            <td
                                              key={field}
                                              className=" px-2 py-1 text-xs text-gray-700"
                                            >
                                              {isValidValue(address[field])
                                                ? field === "state"
                                                  ? stateCodeToLabel[
                                                      address[field]
                                                    ] || address[field]
                                                  : field
                                                        .toLowerCase()
                                                        .includes(
                                                          "date_of_reporting",
                                                        )
                                                    ? formatDate(address[field])
                                                    : address[field]
                                                : "NA"}
                                            </td>
                                          ))}
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              );
                            })()
                          ) : (
                            <div className="col-span-2 text-center text-gray-500">
                              Data not found
                            </div>
                          )}
                        </Section>

                        {/* PHONE DETAILS */}
                        {/* <Section title="Phone Numbers:">
                                                    {Array.isArray(reportData?.data?.phone) &&
                                                        reportData.data.phone.length > 0 ? (
                                                        (() => {
                                                            const usablePhones = reportData.data.phone.filter(
                                                                (phone) => phone && hasAnyKey(phone)
                                                            );

                                                            if (usablePhones.length === 0) {
                                                                return (
                                                                    <div className="col-span-2 text-center text-gray-500">
                                                                        Data not found
                                                                    </div>
                                                                );
                                                            }

                                                            const columns = getDynamicColumns(usablePhones);

                                                            return (
                                                                <div className="col-span-2 overflow-x-auto">
                                                                    <table className="min-w-full  border-gray-300 text-sm">
                                                                        <thead className="bg-red-800">
                                                                            <tr>

                                                                                {columns.map((col) => (
                                                                                    <th
                                                                                        key={col}
                                                                                        className=" px-2 py-1 text-left font-semibold text-xs text-white"
                                                                                    >
                                                                                        {formatLabel(col)}
                                                                                    </th>
                                                                                ))}
                                                                            </tr>
                                                                        </thead>

                                                                        <tbody>
                                                                            {usablePhones.map((phone, index) => (
                                                                                <tr key={index} className="even:bg-gray-100">

                                                                                    {columns.map((field) => (
                                                                                        <td key={field} className=" text-gray-700 px-2 py-1 text-xs">
                                                                                            {isValidValue(phone[field])
                                                                                                ? field
                                                                                                    .toLowerCase()
                                                                                                    .includes("reported_date")
                                                                                                    ? formatDate(phone[field])
                                                                                                    : phone[field]
                                                                                                : "NA"}
                                                                                        </td>
                                                                                    ))}
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            );
                                                        })()
                                                    ) : (
                                                        <div className="col-span-2 text-center text-gray-500">
                                                            Data not found
                                                        </div>
                                                    )}
                                                </Section> */}

                        {/* EMAIL DETAILS */}
                        {/* <Section title=" Email Address:">
                                                    {Array.isArray(reportData?.data?.email) &&
                                                        reportData.data.email.length > 0 ? (
                                                        (() => {
                                                            const usableEmails = reportData.data.email.filter(
                                                                (email) => email && hasAnyKey(email)
                                                            );

                                                            if (usableEmails.length === 0) {
                                                                return (
                                                                    <div className="col-span-2 text-center text-gray-500">
                                                                        Data not found
                                                                    </div>
                                                                );
                                                            }

                                                            const columns = getDynamicColumns(usableEmails);

                                                            return (
                                                                <div className="col-span-2 overflow-x-auto">
                                                                    <table className="min-w-full border-gray-300 text-sm">
                                                                        <thead className="bg-red-800 text-white">
                                                                            <tr>

                                                                                {columns.map((col) => (
                                                                                    <th
                                                                                        key={col}
                                                                                        className=" px-2 py-1 text-left font-semibold text-xs"
                                                                                    >
                                                                                        {formatLabel(col)}
                                                                                    </th>
                                                                                ))}
                                                                            </tr>
                                                                        </thead>

                                                                        <tbody>
                                                                            {usableEmails.map((email, index) => (
                                                                                <tr key={index} className="even:bg-gray-100">

                                                                                    {columns.map((field) => (
                                                                                        <td key={field} className=" px-2 py-1 break-all text-xs text-gray-800">
                                                                                            {isValidValue(email[field])
                                                                                                ? field
                                                                                                    .toLowerCase()
                                                                                                    .includes("reported_date")
                                                                                                    ? formatDate(email[field])
                                                                                                    : email[field]
                                                                                                : "NA"}
                                                                                        </td>
                                                                                    ))}
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            );
                                                        })()
                                                    ) : (
                                                        <div className="col-span-2 text-center text-gray-500">
                                                            Data not found
                                                        </div>
                                                    )}
                                                </Section> */}

                        <Section title="Equifax Score(s):">
                          {Array.isArray(reportData?.data?.score_detail) &&
                          reportData?.data?.score_detail?.length > 0 ? (
                            <div className="overflow-x-auto col-span-2 w-full">
                              <table className="min-w-full border-collapse text-sm">
                                <thead className="bg-red-800 text-white">
                                  <tr>
                                    <th className="px-2 py-1 text-left">
                                      Score Name
                                    </th>
                                    <th className="px-2 py-1 text-left">
                                      Score
                                    </th>
                                    <th className="px-2 py-1 text-left">
                                      Scoring Element
                                    </th>
                                    <th className="px-2 py-1 text-left">
                                      Code
                                    </th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {reportData?.data?.score_detail?.map(
                                    (score, i) => {
                                      const elements =
                                        score?.scoring_elements?.filter(
                                          (e) => e && hasAnyKey(e),
                                        ) || [];
                                      const rowCount = Math?.max(
                                        elements?.length,
                                        1,
                                      );

                                      if (elements.length === 0) {
                                        return (
                                          <tr key={i}>
                                            <td className="px-2 py-1">
                                              {score?.name || "NA"}
                                            </td>
                                            <td className="px-2 py-1">
                                              {score?.value || "NA"}
                                            </td>
                                            <td className="px-2 py-1 text-gray-500">
                                              No elements
                                            </td>
                                            <td className="px-2 py-1">NA</td>
                                          </tr>
                                        );
                                      }

                                      return elements.map((el, idx) => (
                                        <tr
                                          key={`${i}-${idx}`}
                                          className="even:bg-gray-100"
                                        >
                                          {/* print once */}
                                          {idx === 0 && (
                                            <>
                                              <td
                                                rowSpan={rowCount}
                                                className="px-2 py-1 font-medium"
                                              >
                                                {score?.name || "NA"}
                                              </td>

                                              <td
                                                rowSpan={rowCount}
                                                className="px-2 py-1"
                                              >
                                                {score?.value || "NA"}
                                              </td>
                                            </>
                                          )}

                                          <td className="px-2 py-1">
                                            {el?.description || "NA"}
                                          </td>

                                          <td className="px-2 py-1">
                                            {el?.code || "NA"}
                                          </td>
                                        </tr>
                                      ));
                                    },
                                  )}
                                </tbody>
                              </table>
                            </div>
                          ) : (
                            <div className="text-center text-gray-500">
                              Data not found
                            </div>
                          )}
                        </Section>

                        <Section title="Summary:">
                          <div className="col-span-3 w-full font-bold text-white bg-red-800 text-sm px-2 py-1 text-center">
                            Credit Report Summary
                          </div>

                          {hasAnyAccountSummary ? (
                            Object.entries(accountSummary).map(
                              ([key, value]) => (
                                <Detail
                                  key={key}
                                  label={formatLabel(key)}
                                  value={
                                    isValidValue(value)
                                      ? typeof value === "string" &&
                                        !isNaN(value)
                                        ? formatTwoDecimal(value)
                                        : value
                                      : "NA"
                                  }
                                />
                              ),
                            )
                          ) : (
                            <div className="col-span-2 text-center text-gray-500">
                              Data not found
                            </div>
                          )}
                        </Section>

                        <Section
                          title="Account Details:"
                          className="print-page-break"
                        >
                          {Array.isArray(reportData?.data?.account_detail) &&
                          reportData?.data?.account_detail?.length > 0 ? (
                            reportData?.data?.account_detail?.map(
                              (account, index) => {
                                // Case: empty object or null
                                if (!account || !hasAnyKey(account)) {
                                  return (
                                    <div
                                      key={index}
                                      className="col-span-2 mt-24 print-page-break"
                                    >
                                      <div className="font-semibold text-red-700 mb-2">
                                        Account Number {index + 1}
                                      </div>
                                      <div className="text-gray-500">
                                        No record found
                                      </div>
                                    </div>
                                  );
                                }

                                return (
                                  <div
                                    key={index}
                                    className={`col-span-2 ${index > 0 ? "print-page-break " : ""}`}
                                  >
                                    <div className="font-semibold text-white text-center bg-red-800 py-1">
                                      Account Number {index + 1}
                                    </div>

                                    {/* MAIN ACCOUNT INFO */}
                                    <div className="border p-1 grid grid-cols-4 gap-0">
                                      {Object.entries(account)
                                        .filter(
                                          ([key]) =>
                                            key !==
                                            "last_four_year_history_data",
                                        )
                                        .map(([field, value]) => (
                                          <Detail
                                            key={field}
                                            label={formatLabel(field)}
                                            value={
                                              isValidValue(value)
                                                ? field
                                                    .toLowerCase()
                                                    .includes("date")
                                                  ? formatDate(value)
                                                  : value
                                                : "NA"
                                            }
                                          />
                                        ))}
                                    </div>

                                    {/* PAYMENT HISTORY */}
                                    <div className="col-span-2 mt-2  payment-history-wrapper">
                                      <div className="font-semibold text-gray-700 mb-1">
                                        Payment History (Last 4 Years)
                                      </div>

                                      {(() => {
                                        const history =
                                          account.last_four_year_history_data.filter(
                                            (item) => item && hasAnyKey(item),
                                          );

                                        if (history.length === 0) {
                                          return (
                                            <div className="text-gray-500">
                                              No payment history found
                                            </div>
                                          );
                                        }

                                        const months = history.map(
                                          (h) => h.key,
                                        );
                                        const monthChunks = chunkArray(
                                          months,
                                          11,
                                        );

                                        // ✅ DYNAMIC & SAFE — adapts to ANY JSON change
                                        const rowKeys = Array.from(
                                          new Set(
                                            history.flatMap((item) =>
                                              Object.keys(item),
                                            ),
                                          ),
                                        ).filter((k) => k !== "key");

                                        const rows = rowKeys.map((key) => ({
                                          key,
                                          label: formatLabel(key),
                                        }));

                                        return (
                                          <div className="space-y-4 ">
                                            {monthChunks.map((chunk, idx) => (
                                              <table
                                                key={idx}
                                                className="w-full border border-gray-300 text-[9px] border-collapse print-table  "
                                              >
                                                <thead className="mb-20">
                                                  <tr className="">
                                                    <th className="border text-left font-semibold text-gray-500  ">
                                                      Status
                                                    </th>
                                                    {chunk.map((month) => (
                                                      <th
                                                        key={month}
                                                        className="border text-center font-semibold min-w-[16px]"
                                                      >
                                                        {month}
                                                      </th>
                                                    ))}
                                                  </tr>
                                                </thead>

                                                <tbody>
                                                  {rows.map((row) => (
                                                    <tr
                                                      key={row.key}
                                                      className=""
                                                    >
                                                      <td className="border font-semibold  text-gray-500">
                                                        {row.label}
                                                      </td>

                                                      {chunk.map((month) => {
                                                        const item =
                                                          history.find(
                                                            (h) =>
                                                              h.key === month,
                                                          );
                                                        return (
                                                          <td
                                                            key={month}
                                                            className="border text-center "
                                                          >
                                                            {item &&
                                                            isValidValue(
                                                              item[row.key],
                                                            )
                                                              ? item[row.key]
                                                              : "NA"}
                                                          </td>
                                                        );
                                                      })}
                                                    </tr>
                                                  ))}
                                                </tbody>
                                              </table>
                                            ))}
                                          </div>
                                        );
                                      })()}
                                    </div>
                                  </div>
                                );
                              },
                            )
                          ) : (
                            <div className="col-span-2 text-center text-gray-500">
                              Data not found
                            </div>
                          )}
                        </Section>

                        <Section title="List Of Institution:">
                          {Array.isArray(
                            reportData?.data?.list_of_institution,
                          ) ? (
                            (() => {
                              const usableInstitutions =
                                reportData.data.list_of_institution.filter(
                                  (inst) => inst && hasAnyKey(inst),
                                );

                              if (usableInstitutions.length === 0) {
                                return (
                                  <div className="col-span-2 text-center text-gray-500">
                                    Data not found
                                  </div>
                                );
                              }

                              const columns =
                                getInstitutionColumns(usableInstitutions);

                              return (
                                <div className="col-span-2 overflow-x-auto">
                                  <table className="min-w-full   text-sm">
                                    <thead className="border-red-800 bg-red-800 text-white">
                                      <tr>
                                        <th className=" px-2 py-1 font-semibold text-xs">
                                          S.No.
                                        </th>
                                        {columns.map((col) => (
                                          <th
                                            key={col}
                                            className=" px-2 py-1 text-left font-semibold text-xs"
                                          >
                                            {formatLabel(col)}
                                          </th>
                                        ))}
                                      </tr>
                                    </thead>

                                    <tbody>
                                      {usableInstitutions.map(
                                        (institution, index) => (
                                          <tr
                                            key={index}
                                            className="even:bg-gray-100"
                                          >
                                            <td className=" px-2 py-1 font-medium text-xs text-gray-800">
                                              {index + 1}
                                            </td>

                                            {columns.map((field) => (
                                              <td
                                                key={field}
                                                className=" px-2 py-1 text-xs text-gray-800"
                                              >
                                                {isValidValue(
                                                  institution[field],
                                                )
                                                  ? institution[field]
                                                  : "NA"}
                                              </td>
                                            ))}
                                          </tr>
                                        ),
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              );
                            })()
                          ) : (
                            <div className="col-span-2 text-center text-gray-500">
                              Data not found
                            </div>
                          )}
                        </Section>

                        <div className="w-full  mx-auto mt-2">
                          <div className="bg-white overflow-hidden">
                            {/* Header */}
                            <div className=" px-2 py-1  border-gray-300">
                              <h2 className="text-xs sm:text-xl font-semibold text-gray-600">
                                Glossary, Terms and Explanations:
                              </h2>
                            </div>

                            {/* Table Container */}
                            <div className="overflow-x-auto mt-2">
                              <div className="md:text-black text-black text-sm">
                                <u>History</u>
                              </div>
                              <table className="w-full border-collapse text-[12px] ">
                                <thead>
                                  <tr className="bg-[#8B1A1A] text-white">
                                    <th className=" text-center px-2 py-1  font-semibold border-r border-white w-16 sm:w-20">
                                      Code
                                    </th>
                                    <th className="text-center px-2 py-1 font-semibold">
                                      Description
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {glossaryData.map((item, index) => (
                                    <tr
                                      key={index}
                                      className={`${
                                        index % 2 === 0
                                          ? "bg-white"
                                          : "bg-gray-50"
                                      } hover:bg-blue-50 transition-colors border-b border-gray-200`}
                                    >
                                      <td className="px-2 py-0.5 text-center font-semibold text-gray-800 border-r border-gray-200">
                                        {item.code}
                                      </td>
                                      <td className="px-2 py-0.5 text-gray-700">
                                        {item.description}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        {/* FOOTER */}
        <div className="border-t bg-white p-4 flex justify-center gap-4 sticky bottom-0">
          <button
            className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-700 disabled:opacity-50"
            onClick={printDiv}
            disabled={isPrinting}
          >
            Print
          </button>

          <button
            className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-700"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

/* Reusable helpers */
const Section = ({ title, children, className = "" }) => (
  <div className={`border-b section-block ${className}`}>
    <div className="section-title px-4 text-lg mt-2 text-gray-500">{title}</div>
    <div className="section-body grid grid-cols-2 gap-1 pt-1 pb-1 ">
      {children}
    </div>
  </div>
);

const Detail = ({ label, value }) => (
  <div className="">
    <spam className="text-gray-500 italic text-xs">{label}:</spam>{" "}
    <spam className="text-xs">{value}</spam>
  </div>
);

export default EquifaxReport;
